import useSWR, { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';
import {
    SetDataListingReviewedDto,
    SubjectDataListingReviewInstance,
} from '@interfaces-clean/subject-monitoring/subject-data-listing-review';
import { SubjectReviewActivityLogApi } from '@apis/bff-api/subject-monitoring/subject-review-activity-log';
import { SubjectReviewInstanceApi } from '@apis/bff-api/subject-monitoring/subject-review-instance';
import { getData, postData } from '@apis/rest-client';

const subjectDataListingReviewUrl = 'SubjectMonitoring/SubjectReview';
const timeout = 30000;
const fetchOptions = { timeout };

export const SubjectDataListingReviewInstanceApi = {
    useGetDataListingReviewInstanceQuery: (
        studyRef: string,
        reviewRecordId: number | null | undefined,
        subjectId: number | null | undefined,
        dataListingId: string | null | undefined,
    ) => {
        const key =
            reviewRecordId != null && subjectId != null && dataListingId != null
                ? `${subjectDataListingReviewUrl}/GetDataListingReviewInstance/${studyRef}/${reviewRecordId}/${subjectId}/${dataListingId}`
                : null;

        return useSWR(key, async (url) => {
            const result = await getData<SubjectDataListingReviewInstance | ''>(url, fetchOptions);

            // For some reason, the api returning null results in '' and not null...
            return result === '' ? null : result;
        });
    },

    useGetAllDataListingReviewInstancesForReviewQuery: (
        studyRef: string,
        reviewRecordId: number | null | undefined,
    ) => {
        const key =
            reviewRecordId != null
                ? `${subjectDataListingReviewUrl}/GetAllDataListingReviewInstancesForReview/${studyRef}/${reviewRecordId}`
                : null;

        return useSWR(key, (url) => {
            return getData<SubjectDataListingReviewInstance[]>(url, fetchOptions);
        });
    },

    useSetDataListingReviewedMutation: (studyRef: string) => {
        const key = `${subjectDataListingReviewUrl}/SetDataListingReviewed/${studyRef}`;

        return useSWRMutation(key, async (url, { arg }: { arg: SetDataListingReviewedDto }) => {
            const result = await postData<SetDataListingReviewedDto, boolean>(url, { arg, timeout });

            const { reviewRecordId, subjectId, dataListingId } = arg;
            // Invalidate query that gets the review instance that was updated
            // eslint-disable-next-line no-void
            void mutate(
                `${subjectDataListingReviewUrl}/GetDataListingReviewInstance/${studyRef}/${reviewRecordId}/${subjectId}/${dataListingId}`,
            );
            // Invalidate query that gets all review instances for the affected review
            // eslint-disable-next-line no-void
            void mutate(
                `${subjectDataListingReviewUrl}/GetAllDataListingReviewInstancesForReview/${studyRef}/${reviewRecordId}`,
            );

            // Invalidate get all subjects / activity log queries, since changing a review instance will affect those
            SubjectReviewInstanceApi.invalidateGetAllSubjects();
            SubjectReviewActivityLogApi.invalidateGetActivityEntries();

            return result;
        });
    },
};
